import { jsx as _jsx } from "react/jsx-runtime";
import { TabsWithScroll } from '@web/components/layout/TabsWithScroll';
import { canAccessManagerInsightsSection, getPerformanceInsightsSections, PERFORMANCE_INSIGHTS_SECTIONS, resolvePerformanceInsightsSection } from '@web/components/PerformanceReview/insightsSections';
import { PerformanceInsightsTabPanel } from '@web/components/PerformanceReview/PerformanceInsightsTabPanel';
import { useUserContext } from '@web/contexts/User';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { Page } from '@web/pages/layout/Page';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { usePageTitle } from '@web/utility/hooks/usePageTitle';
import { PerformanceReviewSectionsEnum } from '@workalizer/shared';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export var PerformanceInsightsView = function () {
    var _a;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var _b = useFilters(), userId = _b.user, pageSection = _b.pageSection, orgUnitId = _b.orgUnit;
    var users = useWorkspaceCtx().users;
    var currentUser = useUserContext().currentUser;
    var canAccessManagerSection = canAccessManagerInsightsSection({
        isAdmin: (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAdmin) !== null && _a !== void 0 ? _a : false,
        role: currentUser === null || currentUser === void 0 ? void 0 : currentUser.role
    });
    var sections = getPerformanceInsightsSections(canAccessManagerSection);
    usePageTitle(t('metaTitles.performanceInsights'));
    var user = users.find(function (user) { return user.id === userId; });
    useEffect(function () {
        var _a;
        var newFilters = {};
        if (!pageSection) {
            newFilters.pageSection = PERFORMANCE_INSIGHTS_SECTIONS[0];
        }
        else if (pageSection === PerformanceReviewSectionsEnum.MANAGER_ONLY &&
            !canAccessManagerSection) {
            newFilters.pageSection = PERFORMANCE_INSIGHTS_SECTIONS[0];
        }
        if (user && ((_a = user.orgUnit) === null || _a === void 0 ? void 0 : _a.id) && !orgUnitId) {
            newFilters.orgUnit = user.orgUnit.id;
        }
        if (Object.keys(newFilters).length > 0) {
            navigateTo({
                pathname: location.pathname,
                newFilters: newFilters
            });
        }
    }, [
        pageSection,
        user,
        orgUnitId,
        navigateTo,
        location.pathname,
        canAccessManagerSection
    ]);
    var tabs = sections.map(function (section) { return ({
        name: t("app.performanceReview.employeePerformanceReview.".concat(section)),
        id: section,
        Component: PerformanceInsightsTabPanel
    }); });
    var onChange = function (id) {
        navigateTo({
            pathname: location.pathname,
            newFilters: { pageSection: id }
        });
    };
    var currentSection = resolvePerformanceInsightsSection(pageSection, sections);
    return (_jsx(Page, { children: _jsx(TabsWithScroll, { active: currentSection, tabs: tabs, onChange: onChange }) }));
};
